const basePath = '/api/listing/portal/listing/v1';

export const PDP_SINGLE = (id: string) => `${basePath}/load/` + id;
export const PDP_CONTACT_INFO = (id: string) => `${basePath}/contact-info/${id}?source=PDP`;
export const SIMILAR = (id: string) => `${basePath}/similar/${id}`;
export const TRACK = (id: string) => `${basePath}/load/track/${id}?source=PDP`;
